import { api } from './authenticationApi';

export const paymentApi = {
  topUpWallet: async (amount) => {
    const response = await api.makeAuthenticatedRequest('/payments/create-checkout-session', {
      method: 'POST',
      body: { 
        amount,
        task: 'wallet_topup'
      }
    });
    return response.sessionId;
  },
  getUserDetails: async () => {
    const response = await api.makeAuthenticatedRequest('/user/details', {
      method: 'GET'
    });
    return response;
  },
  updateUserAttributes: async (attributes) => {
    const response = await api.makeAuthenticatedRequest('/user/attributes', {
      method: 'POST',
      body: { attributes }
    });
    return response;
  },
  checkResearchEligibility: async (numQuestions, numPersonas, isRegeneration = false) => {
    const response = await api.makeAuthenticatedRequest('/payments/check-research-eligibility', {
      method: 'POST',
      body: { 
        numQuestions,
        numPersonas,
        isRegeneration
      }
    });
    return response;
  },
  createSubscription: async () => {
    try {
      const response = await api.makeAuthenticatedRequest('/payments/create-subscription', {
        method: 'POST',
        body: { plan: 'SUB' }
      });
      return response.sessionId;
    } catch (error) {
      if (error.response?.data?.redirectToAccount) {
        // Handle redirect to account page if user already has subscription
        window.location.href = '/account';
        return null;
      }
      throw error;
    }
  },
  cancelSubscription: async () => {
    const response = await api.makeAuthenticatedRequest('/payments/cancel-subscription', {
      method: 'POST'
    });
    return response;
  },
  getSubscriptionDetails: async () => {
    const response = await api.makeAuthenticatedRequest('/payments/subscription-details', {
      method: 'GET'
    });
    return response;
  },
  useCredit: async () => {
    const response = await api.makeAuthenticatedRequest('/payments/use-credit', {
      method: 'POST'
    });
    return response;
  },
  buyCredits: async (credits) => {
    const response = await api.makeAuthenticatedRequest('/payments/buy-credits', {
      method: 'POST',
      body: { credits }
    });
    return response.sessionId;
  },
  reactivateSubscription: async () => {
    const response = await api.makeAuthenticatedRequest('/payments/reactivate-subscription', {
      method: 'POST'
    });
    return response;
  },
  refundCredit: async () => {
    const response = await api.makeAuthenticatedRequest('/payments/refund-credit', {
      method: 'POST'
    });
    return response;
  },
  deleteAccount: async () => {
    const response = await api.makeAuthenticatedRequest('/user/account', {
      method: 'DELETE'
    });
    return response;
  }
};